module.exports = __webpack_public_path__ + "img/ji7.de12d712.png";